<transaction-list-header-template
  (closeEmitter)="closeEmitter?.emit()"
  [activity]="activity"
  [canOpen]="canOpen"
  [transaction]="transaction">
  <ng-container symbol>
    @if (showIndexIcon()) {
      <img
        class="image-size"
        [src]="tradable?.getLogo()"
        (error)="img.src = tradable?.getDefaultLogo()"
        alt="{{ 'logo_alt_text' | translate }}"
        #img />
    } @else {
      <span class="symbol-wallet">
        @if (!isRebalancingTx()) {
          <span class="bpi__icon-tx-{{ getIconSuffix() }}" [ngClass]="{ isOpen: !canOpen }"></span>
        } @else {
          <span class="bpi__icon-rebalance font-size-20"></span>
        }
      </span>
    }
  </ng-container>
  <ng-container status>
    <span class="information-trade-title">
      {{ "tx_list_item_" + transaction?.getType() | translate: [tradable?.getSymbol(false, true)] }}
    </span>
  </ng-container>
  <ng-container transaction>
    @if (!isRebalancingTx()) {
      <span>{{ getRecipientPrefix() | translate }}: {{ fiatWallet?.getName() }}</span>
    } @else {
      <span class="color-text">
        {{ getAddedTx() }} {{ "rebalance_tx_added" | translate }}, {{ getRemovedTx() }}
        {{ "rebalance_tx_removed" | translate }}, {{ getRebalancedTx() }}
        {{ "rebalance_tx_rebalanced" | translate }}
      </span>
    }
  </ng-container>
  <ng-container amounts>
    @if (!isRebalancingTx()) {
      <div
        class="amount"
        hidePortfolioValue
        [isHideActive]="isWidget && (isHideValueActive$ | async)">
        <div class="amount-main" [ngClass]="{ isOpen: !canOpen, 'price-up': !isOutgoing() && !isIndexClaim }">
          {{
          getTotalAmount()
          | fiat_precision_symbol: { id: getFiat()?.getId(), symbol: true, currencies: [getFiat()] }
          | value_change_prefix: { isProfit: !isOutgoing() && !isIndexClaim }
          }}
        </div>
      </div>
    }
  </ng-container>
</transaction-list-header-template>
